/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export var Content360ContentGroupingType;
(function (Content360ContentGroupingType) {
    Content360ContentGroupingType["MoreCoverage"] = "moreCoverage";
    Content360ContentGroupingType["MorePerspectives"] = "morePerspectives";
    Content360ContentGroupingType["RelatedCoverage"] = "relatedCoverage";
    Content360ContentGroupingType["Timeline"] = "timeline";
})(Content360ContentGroupingType || (Content360ContentGroupingType = {}));
//# sourceMappingURL=Content360ContentGroupingType.js.map